var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChangePwd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_4365_3624)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#325DA0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9459 16.6667C15.9459 17.3538 15.4168 17.9048 14.7568 17.9048C14.0968 17.9048 13.5676 17.3476 13.5676 16.6667C13.5676 15.9795 14.0968 15.4286 14.7568 15.4286C15.4168 15.4286 15.9459 15.9857 15.9459 16.6667ZM15.4049 19.7619C15.4762 20.2076 15.6249 20.6224 15.833 21H11.1892C10.5292 21 10 20.4429 10 19.7619V13.5714C10 12.8843 10.5292 12.3333 11.1892 12.3333H11.7838V11.0952C11.7838 9.38667 13.1157 8 14.7568 8C16.3978 8 17.7297 9.38667 17.7297 11.0952V12.3333H18.3243C18.9843 12.3333 19.5135 12.8905 19.5135 13.5714V15.4843C19.3173 15.4533 19.1211 15.4286 18.9189 15.4286C18.7168 15.4286 18.5205 15.4533 18.3243 15.4843V13.5714H11.1892V19.7619H15.4049ZM12.973 12.3333H16.5405V11.0952C16.5405 10.0676 15.7438 9.2381 14.7568 9.2381C13.7697 9.2381 12.973 10.0676 12.973 11.0952V12.3333ZM20.3103 17.1867L18.1757 19.409L17.2303 18.4248L16.5405 19.1429L18.1757 21L21 18.0595L20.3103 17.1867Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_4365_3624",
    x: -16,
    y: -16,
    width: 62,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4365_3624"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4365_3624",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChangePwd);
export default __webpack_public_path__ + "static/media/icon_change_pwd.e3aaff829e38e3d85a0dcbae3ba33178.svg";
export { ForwardRef as ReactComponent };